import React, { FC } from 'react';
import ReactMarkdown from 'markdown-to-jsx';
import classNames from 'classnames';
import { MarkdownLink } from './Link';
import { MarkdownParagraph } from './Paragraph';
import { MarkdownHeadline } from './Headline';
import { MarkdownPre } from './MarkdownPre';
import { MarkdownCode } from './MarkdownCode';
import { MarkdownItalic } from './MarkdownItalic';
import { MarkdownStrong } from './MarkdownStrong';
import { MarkdownImage } from './Image';
import { MarkdownUnorderedList } from './UnorderedList';
import { MarkdownOrderedList } from './OrderedList';
import { MarkdownProps } from './props';
import './styles.scss';

export const Markdown: FC<MarkdownProps> = ({ wrapperClassName, markdown, style }) => {
  if (!markdown) {
    return null;
  }

  return (
    <div className={classNames('markdown', wrapperClassName)} style={style}>
      <ReactMarkdown
        options={{
          overrides: {
            a: MarkdownLink,
            blockquote: MarkdownParagraph,
            code: MarkdownCode,
            em: MarkdownItalic,
            h1: MarkdownHeadline,
            h2: MarkdownHeadline,
            h3: MarkdownHeadline,
            h4: MarkdownHeadline,
            h5: MarkdownHeadline,
            h6: MarkdownHeadline,
            img: MarkdownImage,
            ol: MarkdownOrderedList,
            p: MarkdownParagraph,
            pre: MarkdownPre,
            strong: MarkdownStrong,
            ul: MarkdownUnorderedList,
          },
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
};
